<template>
  <!-- 运单签收 -->
  <div class="pagesBox">
    <div class="formbox">
      <el-form
        :model="baseInForm"
        :rules="rules"
        ref="baseInFormRef"
        label-width="90px"
        class="glo_formBox"
        size="mini"
      >
        <!--  -->
        <el-row :gutter="20" style="width: 100%">
          <el-col :span="7">
            <el-form-item
              label="签收人:"
              prop="signForName"
              style="width: 100%"
            >
              <el-input
                v-model="baseInForm.signForName"
                placeholder="默认收货人"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-checkbox
              style="height: 30px; line-height: 30px"
              v-model="baseInForm.isReceiveUserSign"
              label="isReceiveUserSign"
              name="type"
              :true-label="1"
              :false-label="0"
              >默认收货人</el-checkbox
            >
          </el-col>
          <el-col :span="7">
            <el-form-item
              label="签收时间:"
              prop="signForTime"
              style="width: 100%"
            >
              <el-date-picker
                v-model="baseInForm.signForTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item
              label="签收情况:"
              prop="signForSituation"
              style="width: 100%"
            >
              <el-select
                v-model="baseInForm.signForSituation"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="(item, index) in signForSituationList"
                  :key="index"
                  :label="item.showName"
                  :value="item.statusVal"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="width: 100%"> </el-row>
        <el-row :gutter="20" style="width: 100%">
          <el-col :span="7">
            <el-form-item label="代理人手机" style="width: 100%">
              <el-input
                v-model="baseInForm.agentPhone"
                placeholder="请输入代理人手机"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-checkbox
              style="height: 30px; line-height: 30px"
              v-model="baseInForm.isSenderSms"
              label="isReceiveUserSign"
              name="type"
              :true-label="1"
              :false-label="0"
              >短信通知发货人</el-checkbox
            >
          </el-col>
          <el-col :span="7">
            <el-form-item label="到付金额" style="width: 100%">
              <el-input
                v-model="baseInForm.receiveAmount"
                placeholder=""
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="代收货款" style="width: 100%">
              <el-input
                v-model="baseInForm.agentAmount"
                placeholder=""
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="width: 100%">
          <el-col :span="7">
            <el-form-item label="收货人身份证号：" style="width: 100%">
              <el-input
                v-model="baseInForm.receiverIdcardNumber"
                placeholder="请输入收货人身份证号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-checkbox
              style="height: 30px; line-height: 30px"
              v-model="baseInForm.isReceiverSms"
              label="isReceiveUserSign"
              name="type"
              :true-label="1"
              :false-label="0"
              >短信通知收货人</el-checkbox
            >
          </el-col>
          <el-col :span="7">
            <el-form-item label="到付送货费" style="width: 100%">
              <el-input
                v-model="baseInForm.receiveSendFee"
                placeholder=""
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="到付其他费用" style="width: 100%">
              <el-input
                v-model="baseInForm.receiveOtherFee"
                placeholder=""
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="width: 100%">
          <el-col :span="7">
            <el-form-item label="代理人身份证号：" style="width: 100%">
              <el-input
                v-model="baseInForm.agentIdcardNumber"
                placeholder="请输入代理人身份证号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-checkbox
              style="height: 30px; line-height: 30px"
              v-model="baseInForm.isRnOrderSure"
              label="isReceiveUserSign"
              name="type"
              :true-label="1"
              :false-label="0"
              >回单收回确认</el-checkbox
            >
          </el-col>
          <template v-if="baseInForm.isRnOrderSure">
            <el-col :span="7">
              <el-form-item
                label="收回部门:"
                prop="returnDeptId"
                style="width: 100%"
              >
                <!-- <el-select
                  filterable
                  clearable
                  v-model="baseInForm.returnDeptId"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in businessDepts"
                    :key="index"
                    :label="item.deptName"
                    :value="item.deptId"
                  ></el-option>
                </el-select> -->
                <dept-tree
                  v-model="baseInForm.returnDeptId"
                  :multiple="false"
                  :checkStrictly="true"
                ></dept-tree>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item
                label="收回人:"
                prop="returnUserId	"
                style="width: 100%"
              >
                <el-select
                  filterable
                  clearable
                  v-model="baseInForm.returnUserId"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in users"
                    :key="index"
                    :label="item.userName"
                    :value="item.userId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>
          <template v-else>
            <el-col :span="7">
              <div>&nbsp;&nbsp;</div>
            </el-col>
            <el-col :span="7">
              <el-form-item label="应收合计" style="width: 100%">
                <el-input
                  v-model="baseInForm.shouldOutTotal"
                  placeholder=""
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </template>
        </el-row>

        <el-row :gutter="20" style="width: 100%">
          <el-col :span="7">
            <el-form-item
              class="textArea"
              style="width: 100%; height: auto"
              label="备注:"
              prop="remarks"
            >
              <el-input
                type="textarea"
                :rows="2"
                v-model="baseInForm.remarks"
              ></el-input>
            </el-form-item>
            <div class="topBtns">
              <el-button-group>
              <el-button
                style="margin-top: 10px"
                @click="saveBtns(false)"
                type="primary"
                v-permission="'admin:waibill:sign'"
                size="mini"
                class="glo_bgcMainColor gggg"
                >确认签收</el-button
              >
              <el-button-group>
                <el-button
                  style="margin-top: 10px"
                  @click="printIt()"
                  size="mini"
                  type="primary"
                  class="glo_bgcMainColor"
                  >打印</el-button
                >
                <el-button
                  @click="printSetting()"
                  size="mini"
                  type="primary"
                  icon="el-icon-setting"
                  class="glo_bgcMainColor"
                  style="margin-top: 10px;margin-left: 2px;padding-left: 4px;padding-right: 6px;"
                  ></el-button
                >
              </el-button-group>
              <el-button
                style="margin-top: 10px"
                @click="writeOffAll()"
                size="mini"
                type="primary"
                class="glo_bgcMainColor gggg"
                >核销到付费用</el-button
              >
              <el-button
                style="margin-top: 10px"
                @click="clear()"
                size="mini"
                type="primary"
                class="glo_bgcMainColor gggg"
                >清空</el-button
              >
            </el-button-group>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="uploadBox">
              <div class="uploadItem">
                <div class="uploadLaber">签收图片</div>
                <uploadimgs
                  @input="changeFileList"
                  :fileNameLists="fileNameLists"
                  :limit="6"
                ></uploadimgs>
              </div>

              <div class="uploadItem" v-show="baseInForm.isRnOrderSure">
                <div class="uploadLaber">回单图片</div>
                <uploadimgs
                  @input="changeFileList2"
                  :fileNameLists="fileNameLists2"
                  :limit="6"
                ></uploadimgs>
              </div>
            </div>
          </el-col>
          <el-col :span="7" v-show="baseInForm.isRnOrderSure">
            <el-form-item label="应收合计" style="width: 100%">
              <el-input
                v-model="baseInForm.shouldOutTotal"
                placeholder=""
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="glo_Table" style="margin-bottom: 20px">
      <el-table
        header-align="center"
        ref="mytable"
        :data="data"
        border
        stripe
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
        height="100%"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        >
        </el-table-column>
        <el-table-column fixed="left" align="left" type="selection" width="60">
        </el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field == 'waybillNumber' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div class="linkTabel" @click.stop="goYdDetails(scope.row)">
                {{ scope.row.waybillNumber }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="item.field == 'waybillStatusShow' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div
                style="color: #f00"
                v-if="scope.row.waybillStatus == 'yi_zuo_fei:waybill_status'"
              >
                {{ scope.row.waybillStatusShow }}
              </div>
              <div v-else>{{ scope.row.waybillStatusShow }}</div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          >
          </el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="160px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button class="rbtns" @click.stop="checkInOtherFee(scope.row)"
                >录入到付费用</el-button
              >
              <el-button class="rbtns" @click.stop="delRows(scope.row)"
                >移除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <my-print
      :classNameArr="classNameArr"
      :modelClassName.sync="modelClassName"
      :getApiType="true"
      modelTypeVal="运单打印模板"
      ref="myPrint"
      :dataSource="printDataSource"
      :add-permission="'admin:waibill:sign:print:add:common'"
      :edit-permission="'admin:waibill:sign:print:edit:common'"
      :del-permission="'admin:waibill:sign:print:del:common'"
    ></my-print>
    <my-dialog
      diaWidth="330px"
      dialogTitle="其他费用"
      :isShowDialog="showOtherFeeDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="handleCloseDia"
      @diaConfirmBtn="diaConfirmBtn"
    >
      <div class="">
        <el-form
          class="diaForm"
          v-if="showOtherFeeDialog"
          ref="dialogFormRef2"
          :model="otherFeeForm"
          label-width="100px"
        >
          <el-form-item
            style="width: 100%"
            class="dialogFormItems"
            prop="waybillNumber"
            label="运单号:"
          >
            <el-input v-model="otherFeeForm.waybillNumber" disabled></el-input>
          </el-form-item>
          <el-form-item
            style="width: 100%"
            class="dialogFormItems"
            prop="receiveSendFee"
            label="到付送货费:"
          >
            <el-input v-model="otherFeeForm.receiveSendFee"></el-input>
          </el-form-item>
          <el-form-item
            style="width: 100%"
            class="dialogFormItems"
            prop="receiveOtherFee"
            label="到付其他费用:"
          >
            <el-input v-model="otherFeeForm.receiveOtherFee"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </my-dialog>
    <my-dialog
      diaWidth="1000px"
      dialogTitle="核销导到付费用"
      :isShowDialog="isShowDialog4WriteOffAll"
      @handleCloseDia="handleCloseDia4WriteOffAll()"
      @diaCancelBtn="handleCloseDia4WriteOffAll()"
      @diaConfirmBtn="diaConfirmBtn4WriteOffAll()"
    >
      <el-form label-position="right" label-width="100px" class="glo_box">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="到付总额">
              <el-input
                v-model="writeOffAllForm.receiveTotalAmount"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="核销资金账号">
              <!-- <el-input v-model="writeOffAllForm.accountId" disabled></el-input> -->
              <el-select v-model="writeOffAllForm.accountId">
                <el-option
                  v-for="account in accountList"
                  :value="account.assetaccountId"
                  :label="account.account"
                  :key="account.assetaccountId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="核销时间">
              <el-date-picker
                type="datetime"
                v-model="writeOffAllForm.writeOffTime"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                type="textarea"
                v-model="writeOffAllForm.writeoffComment"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="图片">
              <uploadimgs
                @input="changeFileList44"
                :fileNameLists="writeOffAllForm.writeOffPics"
                :limit="6"
              ></uploadimgs>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="操作时间">
              <el-input
                v-model="writeOffAllForm.oprationTime"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="操作人">
              <el-input
                v-model="writeOffAllForm.oprationer"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </my-dialog>
    <my-dialog
      diaWidth="600px"
      dialogTitle="注意是否已签收回单并收回！"
      :isShowDialog="isShowRnOrderConfirm"
      @handleCloseDia="handleCloseDia4RnOrderConfirm()"
      @diaCancelBtn="handleCloseDia4RnOrderConfirm()"
      @diaConfirmBtn="diaConfirmBtn4RnOrderConfirm()"
      cancelText="取消签收"
      confirmText="继续签收"
    >
      <el-table :data="rnOrder" max-height="300">
        <el-table-column prop="waybillNumber" label="运单号"></el-table-column>
        <el-table-column
          prop="rnRequireName"
          label="回单要求"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="rnRequireCount"
          label="回单份数"
          width="120"
        ></el-table-column>
      </el-table>
    </my-dialog>
  </div>
</template>
<script>
import uploadimgs from "@/components/MyImageUpload.vue";
import MyPrint from "@/components/print/MyPrint.vue";
import MyDialog from "@/components/Dialog.vue";
import DeptTree from "@/components/DeptTree.vue";
export default {
  components: { uploadimgs, MyPrint, MyDialog, DeptTree },
  props: {
    data: {
      type: Array,
      require: false,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      isRnOrderSure: [],
      baseInForm: {
        waybillSplitId: "",
        isReceiveUserSign: 1,
        isReceiverSms: 0,
        isSenderSms: 0,
        isRnOrderSure: 0,
        remarks: "",
        returnDeptId: this.$TOOLS.getUserInfo().departmentId || null,
        returnUserId: this.$TOOLS.getUserInfo().userId
          ? parseInt(this.$TOOLS.getUserInfo().userId)
          : null,
        rnOrderFileIds: [],
        signForFileIds: [],
        signForName: "",
        signForSituation: "",
        waybillNumbers: "",
        receiverIdcardNumber: "",
        agentIdcardNumber: "",
        agentPhone: "",
        signForTime: "",
        agentAmount: 0,
        receiveAmount: 0,
        receiveSendFee: 0,
        receiveOtherFee: 0,
        shouldOutTotal: 0,
      },
      fileNameLists: [],
      fileNameLists2: [],
      totalArr: [],
      rules: {
        signForName: [{ required: true, message: "请输入", trigger: "blur" }],
        signForSituation: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        signForTime: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      CustomerList: [],
      signForSituationList: [], //签收情况
      // 默认表头
      myTableHeard: [
        {
          name: "到付送货费",
          field: "receiveSendFee",
          width: "160",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "到付其他费用",
          field: "receiveOtherFee",
          width: "160",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "运单号",
          field: "waybillNumber",
          width: "160",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "送货批次号",
          field: "dispatchNumber",
          width: "160",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货人",
          field: "receiveContacts",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货单位",
          field: "receiveCompany",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货电话",
          field: "receivePhone",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "件数",
          field: "packageCount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "到付总额",
          field: "receiveTotalAmount",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "到付金额",
          field: "receivedAmount",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "代收货款",
          field: "agentAmount",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "开单网点",
          field: "openOrderDept",
          width: "160",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货人",
          field: "takeContacts",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货单位",
          field: "takeCompany",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货电话",
          field: "takePhone",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "签收人",
          field: "signForUserNamee",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "签收时间",
          field: "signForTime",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "其他费用",
          field: "otherFee",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "交接方式",
          field: "sendMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "回单方式",
          field: "rnRequireName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "回单份数",
          field: "rnRequireCount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "运单状态",
          field: "waybillStatusShow",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "提货状态",
          field: "aaaaaa",
          width: "110",
          sort: 19,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "存在未完成的仓配任务",
          field: "isHasTaskNoCompleteShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "最新运输任务状态",
          field: "taskStatusShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "外发状态",
          field: "outgoingStatusShow",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "当前网点",
          field: "currentDeptName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "业务员",
          field: "businessName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "付款方式",
          field: "settlementMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "是否开票",
          field: "isInvoiceShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "开票税点",
          field: "taxes",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "业务时间",
          field: "businessDate",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "终端网点",
          field: "endDeptName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "业务网点",
          field: "businessDeptName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "外发承运商",
          field: "outboundCarrierName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "运输方式",
          field: "transportMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "提货方式",
          field: "receiveMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "送货方式",
          field: "sendMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "开单运费",
          field: "billingAmount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货省份",
          field: "receiveProvinceName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货城市",
          field: "receiveCityName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货区县",
          field: "receiveAreaName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货详细地址",
          field: "receiveAddress",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货省份",
          field: "takeProvinceName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货城市",
          field: "takeCityName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货区县",
          field: "takeAreaName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货详细地址",
          field: "takeAddress",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "提货地址数量",
          field: "takeAddressCount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "创建时间",
          field: "createTime",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "创建人",
          field: "createUserName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "订单号",
          field: "orderNumber",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      queryData: {
        waybillNumber: "",
      },
      depList: [],
      EmployeeList: [],
      users: [],
      timers: "", //计时器
      selectTableData: [],
      businessDepts: [],
      classNameArr: [
        {
          name: "签收提货清单",
          val: "print_sign_for_data",
        },
        // {
        //   name: "出库单",
        //   val: "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchCkPrintDataV5VO",
        // },
      ], // 默认的模板类型
      modelClassName: "print_sign_for_data",
      showOtherFeeDialog: false,
      otherFeeForm: {},
      editRow: {},
      isShowDialog4WriteOffAll: false,
      writeOffAllForm: {
        writeOffPics: [],
      },
      accountList: [],
      isShowRnOrderConfirm: false,
      rnOrder: [],
    };
  },
  watch: {
    //回单确认
    isRnOrderSure(a, b) {
      if (a.length > 0) {
      } else {
        this.baseInForm.returnDeptId = "";
        this.baseInForm.returnUserId = "";
      }
    },
  },
  created() {},
  mounted() {
    // 根据对象类型获取结算对象的下拉列表
    this.getObjectUserDownList("employee"); //获取员工列表
    this.getUserList();
    //this.getObjectUserDownList("dept"); //获取部门列表
    this.getBusinessDepts();
    // 获取签收情况下拉列表
    this.$TOOLS
      .getStatusValList("bill_tms_waybill_sign_for_v3.sign_for_situation")
      .then((res) => {
        this.signForSituationList = res || [];
        if (this.signForSituationList.length > 0) {
          //默认正常签收
          this.baseInForm.signForSituation = "zheng_chang:sign_for_situation";
        }
      });

    this.baseInForm.signForTime = this.$TOOLS.getCurrentTime();
    this.getAssetaccountList();
  },
  activated() {},
  deactivated() {
    clearInterval(this.timers);
    this.timers = "";
  },
  destroyed() {},
  methods: {
    clear() {
      this.baseInForm = {
        waybillSplitId: "",
        isReceiveUserSign: 1,
        isReceiverSms: 0,
        isSenderSms: 0,
        isRnOrderSure: 0,
        remarks: "",
        returnDeptId: this.$TOOLS.getUserInfo().departmentId || null,
        returnUserId: this.$TOOLS.getUserInfo().userId
          ? parseInt(this.$TOOLS.getUserInfo().userId)
          : null,
        rnOrderFileIds: [],
        signForFileIds: [],
        signForName: "",
        signForSituation: "",
        waybillNumbers: "",
        receiverIdcardNumber: "",
        agentIdcardNumber: "",
        agentPhone: "",
        signForTime: "",
        agentAmount: 0,
        receiveAmount: 0,
        receiveSendFee: 0,
        receiveOtherFee: 0,
        shouldOutTotal: 0,
      };
      this.fileNameLists = [];
      this.fileNameLists2 = [];
      this.$emit("clear");
    },
    async getUserList() {
      const users = await this.$API.runList("admin_user_list");
      this.users = users;
    },
    // 获取已启用的资金账号列表
    getAssetaccountList() {
      this.$API.assetaccountList({ isShow: "1" }).then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result?.data || [];
          this.accountList = result;
        } else {
          console.log(res.data.message);
        }
      });
    },
    writeOffAll() {
      if (this.selectTableData.length == 0) {
        this.$message.warning("还没有选择需要核销的运单");
        return;
      }
      this.writeOffAllForm = {
        receiveTotalAmount: this.baseInForm.shouldOutTotal,
      };
      this.isShowDialog4WriteOffAll = true;
    },
    handleCloseDia4WriteOffAll() {
      this.isShowDialog4WriteOffAll = false;
    },
    async diaConfirmBtn4WriteOffAll(posting) {
      try {
        const res = await this.$API.writeOffAll({
          posting,
          splitIds: this.selectTableData.map((item) => item.waybillSplitId),
          ...this.writeOffAllForm,
          writeOffPics:
            this.writeOffAllForm.writeOffPics &&
            this.writeOffAllForm.writeOffPics.map((item) => item.url),
        });
        this.$message.success("核销成功");
        this.isShowDialog4WriteOffAll = false;
      } catch (err) {
        if (err.data.message === "是否过账并核销") {
          this.$confirm("是否过账并核销", {
            message: "是否过账并核销",
            closeOnClickModal: false,
            closeOnPressEscape: false,
            closeOnHashChange: false,
          })
            .then(() => {
              this.diaConfirmBtn4WriteOffAll(true);
            })
            .catch((errr) => {
              this.isShowDialog4WriteOffAll = false;
            });
        }
      }
    },
    handleCloseDia4RnOrderConfirm() {
      this.isShowRnOrderConfirm = false;
    },
    diaConfirmBtn4RnOrderConfirm() {
      this.isShowRnOrderConfirm = false;
      this.saveBtns(true);
    },
    calcOtherFees() {
      let agentAmount = 0;
      let receiveAmount = 0;
      let receiveSendFee = 0;
      let receiveOtherFee = 0;
      this.selectTableData.map((item) => {
        agentAmount += parseInt(item.agentAmount || 0);
        receiveAmount += parseInt(item.receivedAmount || 0);
        receiveSendFee += parseInt(item.receiveSendFee || 0);
        receiveOtherFee += parseInt(item.receiveOtherFee || 0);
      });
      this.baseInForm.agentAmount = agentAmount;
      this.baseInForm.receiveAmount = receiveAmount;
      this.baseInForm.receiveSendFee = receiveSendFee;
      this.baseInForm.receiveOtherFee = receiveOtherFee;
      this.baseInForm.shouldOutTotal =
        agentAmount + receiveAmount + receiveSendFee + receiveOtherFee;
    },
    // 获取营业网点
    async getBusinessDepts() {
      const data = await this.$API.runListReport({
        number: "business_dept_down_list",
      });
      this.businessDepts = data;
    },
    // 签收按钮
    saveBtns(force = false) {
      let pdata = JSON.parse(JSON.stringify(this.baseInForm));
      let isSenderSms = 1;
      let isReceiverSms = 1;
      let waybillNumbers = [];

      // 处理图片
      let signForFileIds = [];
      let rnOrderFileIds = [];
      // this.fileNameLists.forEach((item) => {
      //   // 签收图片
      //   signForFileIds.push(item.name);
      // });
      // this.fileNameLists2.forEach((item) => {
      //   // 回单图片
      //   rnOrderFileIds.push(item.name);
      // });

      //
      let isHaseTask = false; //是否存在未完成任务, false==不存在
      let wayBillSignStr = ""; //未完成任务的运单
      let waybillSplitIds = [];
      for (var a = 0; a < this.data.length; a++) {
        let item = this.data[a];
        //提取运单号
        waybillNumbers.push(item.waybillNumber);
        waybillSplitIds.push(item.waybillSplitId);

        if (item.isHasTaskNoComplete == 1) {
          isHaseTask = true;
          wayBillSignStr += item.waybillNumber + " ,";
        }
      }

      if (waybillNumbers.length == 0) {
        this.$message.warning("还没有选择需要签收的运单");
        return false;
      }
      if (!force) {
        const aaa = this.data.filter((item) => item.rnRequireName);
        if (aaa.length > 0) {
          this.isShowRnOrderConfirm = true;
          this.rnOrder = aaa;
          return;
        }
      }
      let params = {
        isReceiverSms: this.baseInForm.isReceiverSms,
        isRnOrderSure: this.baseInForm.isRnOrderSure,
        isReceiveUserSign: this.baseInForm.isReceiveUserSign, //默认收货人
        isSenderSms: this.baseInForm.isSenderSms,
        remarks: pdata.remarks || "",
        returnDeptId: pdata.returnDeptId || "",
        returnUserId: pdata.returnUserId || "",
        rnOrderFileIds: this.fileNameLists2,
        signForFileIds: this.fileNameLists,
        signForName: pdata.signForName || "",
        signForSituation: pdata.signForSituation || "",
        agentIdcardNumber: pdata.agentIdcardNumber || "",
        agentPhone: pdata.agentPhone || "",
        receiverIdcardNumber: pdata.receiverIdcardNumber || "",
        signForTime: pdata.signForTime || "",
        waybillNumbers: waybillNumbers || [],
        waybillSplitIds: waybillSplitIds,
      };
      // 判断是否需存在未完成的任务
      if (isHaseTask) {
        this.$confirm(
          "所选运单中存在未完成的任务的任务,是否强制签收? 运单号: " +
            wayBillSignStr,
          "提示: ",
          {
            confirmButtonText: "强制签收",
            cancelButtonText: "取消",
          }
        )
          .then(() => {
            this.saveSignforWaybill(params);
          })
          .catch(() => {});
      } else {
        this.saveSignforWaybill(params);
      }
    },
    // 确认签收接口
    saveSignforWaybill(params) {
      this.$API.signforWaybill(params).then((res) => {
        this.$message.success(res.data.message || "签收成功");

        // this.$emit("signSuccess")
        // this.isRnOrderSure = [];
        // this.fileNameLists = [];
        // this.fileNameLists2 = [];
        // this.baseInForm = {
        //   isReceiverSms: "",
        //   Sms: [],
        //   isSenderSms: "0",
        //   isRnOrderSure: "0",
        //   remarks: "",
        //   returnDeptId: "",
        //   returnUserId: "",
        //   rnOrderFileIds: [],
        //   signForFileIds: [],
        //   signForName: "",
        //   signForSituation: "",
        //   waybillNumbers: "",
        // };
      });
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(key) {
      this.$API
        .wtl_getObjectUserDownList({
          key: key,
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          if (key == "employee") {
            this.EmployeeList = arrs;
          }
          if (key == "dept") {
            this.depList = arrs;
          }
          if (key == "storage") {
            this.storageList = arrs;
          }
        });
    },
    // 移除运单
    delRows(row) {
      this.$confirm("确定移除该运单吗?", "提示:")
        .then((res) => {
          this.$emit("removeOne", row);
        })
        .catch();
    },
    checkInOtherFee(row) {
      this.otherFeeForm = {
        waybillSplitId: row.waybillSplitId,
        waybillNumber: row.waybillNumber,
        receiveSendFee: row.receiveSendFee,
        receiveOtherFee: row.receiveOtherFee,
      };
      this.showOtherFeeDialog = true;
      this.editRow = row;
    },
    // 跳转运单详情
    goYdDetails(row) {
      this.$router.push({
        path: "/WaybillManage/WaybillDetails",
        query: {
          waybillSplitId: row.waybillSplitId,
          waybillNumber: row.waybillNumber,
        },
      });
    },
    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },
    // 选择图片
    changeFileList2(array) {
      this.fileNameLists2 = array;
    },

    changeFileList44(array) {
      this.writeOffAllForm.writeOffPics = array;
    },
    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },
    handleSelectionChange(e) {
      this.selectTableData = e;
      this.calcOtherFees();
    },
    printDataSource(rows) {
      return new Promise((resolve, reject) => {
        this.$API
          .runList({
            number: this.modelClassName,
            waybillSplitIds: rows.map((d) => d.waybillSplitId),
          })
          .then((res) => {
            const result = res;
            resolve(result);
          })
          .catch((err) => {});
      });

      // return new Promise((resolve, reject) => {
      //   this.$API
      //     .ckPrintData({
      //       waybillSplitIds: rows.map((d) => d.waybillSplitId),
      //     })
      //     .then((res) => {
      //       const result = res.data.result;
      //       resolve(result);
      //     })
      //     .catch((err) => {});
      // });
    },
    printIt(setting) {
      this.$refs.myPrint.printEvent(this.selectTableData,setting);
    },
    printSetting() {
      this.$refs.myPrint.printSetting();
    },
    handleCloseDia() {
      this.showOtherFeeDialog = false;
      this.otherFeeForm = {};
    },
    async diaConfirmBtn() {
      await this.$API.updateWaybillFinanceOther({
        ...this.otherFeeForm,
      });
      this.showOtherFeeDialog = false;
      this.editRow.receiveSendFee = this.otherFeeForm.receiveSendFee;
      this.editRow.receiveOtherFee = this.otherFeeForm.receiveOtherFee;
      this.otherFeeForm = {};
      this.calcOtherFees();
    },
  },
};
</script>
<style scoped lang='less'>
.pagesBox {
  height: 100%;
  overflow: auto;
}

.formbox {
  padding: 10px 10px 10px;

  .jsInput {
    .jsBtns {
      height: 30px;
      line-height: 30px;
      margin: 0;
      padding: 0 10px;
      border: none;
    }
  }

  .formBtns {
    height: 33px;
    margin: 0;
    padding: 0 10px;
  }

  .checkBoxStyle {
    width: 23%;
    min-width: 260px;
    margin-bottom: 10px;

    display: flex;
    align-items: center;
  }
}

.uploadBox {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 5px;
  .uploadItem {
    flex: 1;
    display: flex;
    .uploadLaber {
      padding-right: 5px;
      margin-bottom: 10px;
      writing-mode: vertical-rl;
    }
  }
}

.topBtns {
  min-width: 210px;
  .gggg{
    margin-right: 2px;
  }
}
.glo_Table {
  min-height: 200px;
  height: calc(100% - 294px);
}
.el-form-item {
  min-width: unset;
  margin-bottom: 2px !important;
}
.topBtns {
  .el-button {
    padding: 7px 8px;
  }
}
</style>